module.exports = __webpack_public_path__ + "img/25.8bef798f.png";